export enum MessageResultState {
  ERROR = 0,
  SUCCESS = 1,
  WARNING = 2,
}
export interface ServiceResult<T = any> {
  result: T;
  isSuccess: boolean;
  message: string;
  state: MessageResultState;
}
export interface DataTableItemsDto<T> {
  totalCount: number;
  items: T[];
}
export interface Row<T> {
  row: {
    original: T;
  };
}
export interface AxiosResponse<T = any> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  request?: any;
}
export type ComboBoxData = {
  id: number;
  name: string;
  parentId?: string | number | undefined;
};
export type ComboBoxDataStr = {
  id: string;
  name: string;
  parentId?: string | number | undefined;
};
